import { createContext } from 'react';

import type OverlayStatusData from './types/OverlayStatusData';

const OverlayStatusContext = createContext<OverlayStatusData>({
    closeOverlay: () => {},
    forceOverlay: () => {},
    enableParentRedirects: () => {},
    registerBeforeClose: () => {},
    overlayIsClosing: false,
    isProcessingClose: false,
    inOverlay: false,
    parentSupportsRedirects: false,
    openerUrl: window.location.href,
});

export default OverlayStatusContext;
